import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { offcerList, sendInvitationLink } from "./sendLinkAPI";

const initialState = {
  loading: false,
  companyList: [],
};

const actions = {
  SENDINVITATIONLINK: "sendInvitationLink/SENDINVITATIONLINK",
  COMPANYLISTFOROFFICER: "companyListForOfficer/COMPANYLISTFOROFFICER",
};

export const invitationLink = createAsyncThunk(
  actions.SENDINVITATIONLINK,
  async (payload) => {
    const response = await sendInvitationLink(payload);
    return response;
  }
);
export const companyListForOfficer = createAsyncThunk(
  actions.COMPANYLISTFOROFFICER,
  async (payload) => {
    const response = await offcerList(payload);
    return response;
  }
);

export const sendInvitation = createSlice({
  name: "InvitationLink",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(invitationLink.pending, (state) => {
        state.loading = true;
      })
      .addCase(invitationLink.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.loading = true;
        if (success === true) {
          state.loading = false;
          message.success(msg);
        } else {
          state.loading = false;
          message.error(msg);
        }
      })
      .addCase(invitationLink.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    builder
      .addCase(companyListForOfficer.pending, (state) => {
        state.loading = true;
      })
      .addCase(companyListForOfficer.fulfilled, (state, action) => {
        const { success, data } = action.payload;
        state.loading = true;
        if (success === true) {
          state.loading = false;
          state.companyList = data;
        } else {
          state.loading = false;
        }
      })
      .addCase(companyListForOfficer.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
  },
});

export const sendInvitationActions = sendInvitation.actions;
export const { resetPending } = sendInvitation.actions;

export default sendInvitation.reducer;
